package com.starparty.app.astro0.js

import com.starparty.app.astro0.*
import com.starparty.app.astro0.renderers.NightVisionRendererTheme
import com.starparty.app.astro0.renderers.RendererTheme
import com.starparty.app.astro0.renderers.SkyRenderer
import com.starparty.app.geometry.SP_Point
import org.w3c.dom.TouchEvent
import org.w3c.dom.events.Event
import org.w3c.dom.events.MouseEvent
import org.w3c.dom.events.WheelEvent
import org.w3c.dom.get
import kotlin.math.abs

class SP_JSSkyViewCanvasState(val sky: Sky, val spCanvas: SP_JSCanvas): SkyView {

        val htmlCanvas = spCanvas.canvas
        val context = spCanvas.ctx
        var width = htmlCanvas.width
        var height = htmlCanvas.height

        var changed = true

        var mLastAdjPoint: SP_Point = SP_Point()
        var mouseDown = false
        var scaling = false


        val skyRenderer = SkyRenderer(sky)


        val defaultRendererTheme =
            RendererTheme(SP_JSPaint(), SP_JSPaint(), SP_JSPaint(), SP_JSPaint(),
                          SP_JSPaint(), SP_JSPaint(), SP_JSPaint(), SP_JSPaint(),
                          SP_JSPaint(), SP_JSPaint(), SP_JSPaint(), SP_JSPaint(),
                          SP_JSPaint(), SP_JSPaint(), SP_JSPaint())

        val nightVisionRendererTheme =
            NightVisionRendererTheme(SP_JSPaint(), SP_JSPaint(), SP_JSPaint(), SP_JSPaint(),
                                     SP_JSPaint(), SP_JSPaint(), SP_JSPaint(), SP_JSPaint(),
                                     SP_JSPaint(), SP_JSPaint(), SP_JSPaint(), SP_JSPaint(),
                                     SP_JSPaint(), SP_JSPaint(), SP_JSPaint())

        var rt = defaultRendererTheme

        init {
            htmlCanvas.addEventListener("touchstart", { e: Event ->
                val te = e as TouchEvent
                if (te.touches.length === 2) {
                    val x1 = te.touches[0]!!.clientX.toDouble()
                    val y1 = te.touches[0]!!.clientY.toDouble()
                    val x2 = te.touches[1]!!.clientX.toDouble()
                    val y2 = te.touches[1]!!.clientY.toDouble()
                    pinchStart(x1,y1,x2,y2)
                }
                else if (te.touches.length === 1) {
                    val x = te.touches[0]!!.clientX.toDouble()
                    val y = te.touches[0]!!.clientY.toDouble()
                    dragStart(x, y)
                }

                e.preventDefault()
                e.stopPropagation()
                this
            } )

            htmlCanvas.addEventListener("touchmove", { e: Event ->
                val te = e as TouchEvent

                if (te.touches.length === 2) {
                    val x1 = te.touches[0]!!.clientX.toDouble()
                    val y1 = te.touches[0]!!.clientY.toDouble()
                    val x2 = te.touches[1]!!.clientX.toDouble()
                    val y2 = te.touches[1]!!.clientY.toDouble()
                    pinchMove(x1,y1,x2,y2)}

                else if (te.touches.length === 1) {
                    val x = te.touches[0]!!.clientX.toDouble()
                    val y = te.touches[0]!!.clientY.toDouble()
                    dragMove(x, y)
                }

                e.preventDefault()
                e.stopPropagation()
                this
            })

            htmlCanvas.addEventListener("touchend", { e: Event ->

                val te = e as TouchEvent

                if (te.touches.length === 2) {
                    val x1 = te.touches[0]!!.clientX.toDouble()
                    val y1 = te.touches[0]!!.clientY.toDouble()
                    val x2 = te.touches[1]!!.clientX.toDouble()
                    val y2 = te.touches[1]!!.clientY.toDouble()
                    pinchEnd(x1,y1,x2,y2)}

                else if (te.touches.length === 1) {
                    val x = te.touches[0]!!.clientX.toDouble()
                    val y = te.touches[0]!!.clientY.toDouble()
                    dragEnd(x, y)
                }

                e.preventDefault()
                e.stopPropagation()
                //window.alert("touch ended")
                this
            })

            //  htmlCanvas.addEventListener("touchcancel", { window.alert("touch cancelled") } )


            // Mousewheel Zoom
            htmlCanvas.onwheel = { e: WheelEvent ->

                val delY = e.deltaY

                if (delY < 0) {
                    incrementZoomFromCanvasCentre(1 - SP_JSControls.zoomInc)
                } else if (delY > 0) {
                    incrementZoomFromCanvasCentre(1 + SP_JSControls.zoomInc)
                }

                changed = true
                sky.project()
                draw()

                e.preventDefault()
                e.stopPropagation()
                this
            }

            htmlCanvas.onmousedown = { e: MouseEvent ->
                dragStart(e.x, e.y)
                e.preventDefault()
                e.stopPropagation()
                this
            }

            htmlCanvas.onmousemove = { e: MouseEvent ->
                dragMove(e.x, e.y)
                e.preventDefault()
                e.stopPropagation()
                this
            }

            htmlCanvas.onmouseup = { e: MouseEvent ->
                dragEnd(e.x, e.y)
                e.preventDefault()
                e.stopPropagation()
                this
            }

            htmlCanvas.onmouseout = { e: MouseEvent ->
                mouseDown = false
                e.preventDefault()
                e.stopPropagation()

                this
            }

            htmlCanvas.ondblclick = { e: MouseEvent ->

                this
            }
/*
        window.setInterval({
            draw()
        }, interval) */


            changed = true
            sky.project()
            draw()
        }

        var lastDelY = 0.0

        fun pinchStart(x1:Double, y1:Double, x2:Double ,y2:Double) {
            //    window.alert("pinch start")
            scaling = true
            lastDelY = abs(y2 - y1)
        }

        fun pinchMove(x1:Double, y1:Double, x2:Double ,y2:Double) {
            //    window.alert("pinch move")
            val delY = abs(y2 - y1)

            scale(delY)
            lastDelY = delY
        }

        fun pinchEnd(x1:Double, y1:Double, x2:Double ,y2:Double) {
            //    window.alert("pinch end")
            scaling = false
            lastDelY = 0.0
        }

        fun scale(delY: Double) {

            if (delY < lastDelY) {
                incrementZoomFromCanvasCentre(1 - SP_JSControls.zoomInc)
            } else {
                incrementZoomFromCanvasCentre(1 + SP_JSControls.zoomInc)
            }

            changed = true
            sky.project()
            draw()
        }

    fun incrementZoomFromCanvasCentre(inc: Double){

        val x1 = spCanvas.getCentreX()
        val y1 = spCanvas.getCentreY()
        val p1 = SP_Point(x1, y1)
        val equ1 = sky.getEquatorialCoordinates(SP_Point(x1,y1))

        sky.incrementZoom(inc)

        sky.coordinateTransformer.moveEquatorialPointToPoint(equ1.rA, equ1.dec, p1)
    }

        fun dragStart(x:Double, y:Double) {
            mouseDown = true
            val xScrolled = x - spCanvas.canvas.getBoundingClientRect().left
            val yScrolled = y - spCanvas.canvas.getBoundingClientRect().top
            val point = SP_Point(xScrolled, yScrolled)

            mLastAdjPoint = spCanvas.adjustPoint(point)
        }

        fun dragMove(x: Double, y: Double) {

            val xScrolled = x - spCanvas.canvas.getBoundingClientRect().left
            val yScrolled = y - spCanvas.canvas.getBoundingClientRect().top
            val point = SP_Point(xScrolled, yScrolled)
            val adjPoint = spCanvas.adjustPoint(point)

            if (mouseDown) {
                changed = true
                sky.movePointToPoint(mLastAdjPoint, adjPoint)
                sky.project()
                draw()
            }

            mLastAdjPoint = adjPoint

        }

        fun dragEnd(x:Double, y:Double) {

            mouseDown = false
            changed = true
        }


        fun clear() {
            context.fillStyle = rt.backgroundPaint.getNativeColor()

            val topLeft = SP_Point(0.0,0.0)

            val adjTopLeft = spCanvas.adjustPoint(topLeft)

            context.fillRect(adjTopLeft.x, adjTopLeft.y, width.toDouble(), height.toDouble())
        }

        fun draw() {
            if (!changed) return

            changed = false

            clear()

            renderToCanvas()
        }

        fun renderToCanvas() {
    //        sky.project()

            skyRenderer.onDraw(spCanvas, rt)
        }

        fun toggleNightVisionTheme(): Boolean {
            if (rt === defaultRendererTheme) {
                rt = nightVisionRendererTheme
            }
            else {
                rt = defaultRendererTheme
            }

            return rt === nightVisionRendererTheme
        }

    override fun getCanvas(): SP_Canvas {
        return spCanvas
    }
}
